import script from "./ProfileRelationshipCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileRelationshipCard.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileRelationshipCard.vue?vue&type=style&index=0&id=a1f57964&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1f57964"]])

export default __exports__